import { memo } from 'react';
import { Vector2Tuple } from 'three';

import { CommanderActionTypesEnum } from '@spazious/dollhouse-commander';
import { AnnotationDrawControls } from '@spazious/dollhouse-engine';
import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';
import { useStaging } from '@spazious/dollhouse-store';
import { useEventCallback } from '@spazious/react-hooks';

import { AnnotationStatusEnum, useAnnotation } from '../../hooks/useAnnotation.js';

export const AnnotationControls = memo(() => {
  const { annotations, setStatus } = useAnnotation();
  const { staging, createAction } = useStaging();
  const onAddAnnotation = useEventCallback((position: Vector2Tuple) => {
    const action = createAction('add', { type: FShallowNodeTypesEnum.Annotation });
    staging.add(action);
    staging.add(createAction('update', action.payload.selector, 'position', position));
    staging.commit(CommanderActionTypesEnum.Add);
    setStatus(AnnotationStatusEnum.Ready, action.payload.selector);
  });

  return annotations.drawEnabled ? <AnnotationDrawControls onDraw={onAddAnnotation} /> : null;
});
